import React from "react";
// import ReactDOM from "react-dom";
// import Preloader from "./components/Preloader/Preloader";
// import Timer from "./components/Countdown/Timer";
// import Optin from "./components/Optin/Optin";

//import "./styles.css";
import './App.css';


function App() {
  return (
    <div className="App">
      <div className="container">
        <h1>
          <img 
            src="spire_logo.png"
            alt="Spire Logo"
            height={300}
            ></img>
        </h1>
        <br />
        <h2
          style={{
            fontSize: "3rem",
            color: "#3568af",
            textAlign: "center",
            marginTop: "20px",
          }}>
          WEBSITE
          <br />
          COMING SOON
        </h2>
        {/* <Timer />
        <Optin />
        <Preloader /> */}
      </div>
    </div>
  );
}

export default App;